import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { NotificationManager } from 'react-notifications'
import Select from 'react-select'
import { FormGroup, FormSelect } from 'shards-react'
import { fileSharingAddFile } from '../../../../api/fileSharing'
import { getAuthData } from '../../../../redux/reducers/auth-reducer'
import { getOrgList } from '../../../../redux/reducers/organization-list-reducer'
import { getBase64 } from '../../../../utils/getBase64'
import { organizationToOptions } from '../../../../utils/toSelectOption'
import Button from '../../../common/Button'
import { Modal } from '../../../common/Modal'
import { ORG_TYPES } from '../../../../constants/const'

export const FileSharingSentModal = ({ setModalVisible, handleRequesList }) => {
  
  const authData = useSelector(getAuthData)
  const orgList = useSelector(getOrgList)
  
  const [fileSubmitting, setFileSubmitting] = useState(false)
  const [file, setFile] = useState({ filename: null, data: null })
  const [idOrg, setIdOrg] = useState('')
  const [school, setSchool] = useState('1')
  const [error, setError] = useState(false)


  const filteredOrgList =
    school === '0' ? orgList :
    school === '2' ? orgList.filter(({isSchool}) => isSchool !== '0') :
    orgList.filter(({isSchool}) => isSchool === '0')

  const handleFileSubmit = async () => {
    if (!idOrg) return setError(true);
    if (!file.data) return NotificationManager.error('Необходимо выбрать файл');
    setFileSubmitting(true)
    const schoolParam = idOrg == 0 ? school : undefined
    await fileSharingAddFile({ ...authData, idOrg, school: schoolParam, ...file })
    setFileSubmitting(false)
    setModalVisible(false)
    handleRequesList()
  }

  const setFielHandler = e => {
    const file = e.target.files[0]
    getBase64(file).then(data => setFile({ filename: file.name, data }))
  }

  const setIdOrgHandler = orgOptions => {
    const arrIds = orgOptions ? orgOptions.map(e => e.value) : []
    const newIdOrg = arrIds.join(',')
    setIdOrg(newIdOrg)
    if (arrIds.length) setError(false)
    if (newIdOrg !== '0') setSchool('1')
  }

  const errorSelectStyles = {
    control: (base) => ({
      ...base,
      borderColor: 'red',
      boxShadow: 'none',
      '&:hover': { borderColor: 'red' },
    }),
  }

  return (
    <Modal title='Добавить файл' isVisible={true}>
      <input type='file' onChange={setFielHandler} name='file' className='mb-2' />

      <FormGroup className='mb-2'>
        <Select
          placeholder='Выберите организацию'
          options={organizationToOptions(filteredOrgList)}
          onChange={setIdOrgHandler}
          isMulti
          styles={error ? errorSelectStyles : undefined}
        />
        {error && <div style={{ color: 'red', fontSize: '0.85rem', marginTop: '0.25rem' }}>необходимо указать значение</div>}
      </FormGroup>

      {idOrg === '0' && (
        <FormGroup className={'mr-3'}>
          <label htmlFor='school'>Тип ОО</label>
          <FormSelect
            name='school'
            id='school'
            value={school}
            onChange={e => setSchool(e.target.value)}
          >
            {ORG_TYPES.map(({name, value}) => <option key={value} value={value}>{name}</option>)}
          </FormSelect>
        </FormGroup>
      )}

      <Button className='mr-2' label='Отменить' type='button' onClick={() => setModalVisible(false)} />
      <Button label='Сохранить' className='mr-2' type='button' onClick={handleFileSubmit} submitting={fileSubmitting} />
    </Modal>
  )
}
